import type React from 'react';

import qs from 'qs';

import { Button } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core-react/i18n';

type Props = Readonly<{
	/**
	 * Which breakpoint's copy this is: the section renders both so the tab order matches the
	 * visual order - beside the heading from md up, after the cards on mobile.
	 *
	 * Also rendered as `data-see-all-topics`, which `useTrendingSectionFocusFallbackRef` reads at
	 * runtime to re-focus the matching button after the loading skeleton is swapped out.
	 */
	device: 'desktop' | 'mobile';
	onClick: () => void;
}>;

export const SeeAllTopicsButton: React.FC<Props> = ({ device, onClick }) => (
	<Button
		as="a"
		href={`/topic?${qs.stringify({ source_location: 'homepage' })}`}
		variant="secondary"
		size="large"
		className={cn({ 'w-full': device === 'mobile' })}
		data-see-all-topics={device}
		data-testid="trending-section-see-all-button"
		data-qa="trending-section-see-all-button"
		onClick={onClick}
	>
		<Translate value="corgi.homepage.trending_section.see_all_button" />
	</Button>
);
